<template>
    <div class="results-filter">
        <div class="count">
            <ais-stats v-slot="{ nbHits }">
                {{ nbHits }} product{{ nbHits != 1 ? 's' : '' }} found.
            </ais-stats>
        </div>

        <div class="filters">
            <ais-sort-by
                class="sort-by"
                :items="sortableIndexes"
            />

            <div class="filter-type">
                <button
                    @click="toggleLayout"
                    class="results_layout badge --grid"
                    :class="layout == 'grid' ? 'active' : ''"
                >
                    Grid
                </button>
                <button
                    @click="toggleLayout"
                    class="results_layout badge --list"
                    :class="layout == 'list' ? 'active' : ''"
                >
                    List
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['sortIndexes'],
    data: () => ({
        layout: 'grid',
    }),
    computed: {
        sortableIndexes() {
            return [
                { value: `${indexPrefix}products`, label: 'Sort by: Relevance' },
                ...(this.sortIndexes || []).map(index => ({
                    value: `${indexPrefix}products-${index.slug}`,
                    label: `Sort by: ${index.title}`,
                })),
                { value: `${indexPrefix}products-alphabetical`, label: 'Sort by: Title (A-Z)' },
            ]
        },
    },
    methods: {
        toggleLayout() {
            this.layout = this.layout == 'grid' ? 'list' : 'grid'
            this.$emit('changeLayout', this.layout);
        },
    },
}
</script>
